import CryptoJS from "crypto-js";
const encoder = new TextEncoder();
const utf8Bytes = encoder.encode(process.env.REACT_APP_SECRET_KEY);
// const key = CryptoJS.enc.Utf8.parse(String.fromCharCode.apply(null, utf8Bytes));
const key = `b'${process.env.REACT_APP_SECRET_KEY}'`;
export function generateSignature(data) {
  const signature = CryptoJS.HmacSHA256(data, process.env.REACT_APP_SECRET_KEY);
  return signature.toString(CryptoJS.enc.Hex);
}
